'use client';

import dynamic from 'next/dynamic';
import type { ReactNode } from 'react';

import { Toaster } from '@/services/notify/toaster';

import { DatadogProvider } from './datadog-provider/datadog-provider';
import { ReactQueryProvider } from './react-query-provider/react-query-provider';
import { SuperTokensProvider } from './supertokens-provider/supertokens-provider';

const ReactQueryDevtools =
  process.env.NODE_ENV !== 'production'
    ? dynamic(
        () =>
          import('@tanstack/react-query-devtools').then((m) => ({
            default: m.ReactQueryDevtools,
          })),
        { ssr: false }
      )
    : () => null;

export const AppProviders = ({ children }: { children: ReactNode }) => {
  return (
    <DatadogProvider>
      <ReactQueryProvider>
        <SuperTokensProvider>{children}</SuperTokensProvider>
        <Toaster />
        <ReactQueryDevtools initialIsOpen={false} />
      </ReactQueryProvider>
    </DatadogProvider>
  );
};
